<script>
/**
 * @file 教师端首页
 */
import ForkissIcon from '../forkiss-icon';

export default {
    components: {
        ForkissIcon
    },
    methods: {
        viewCenter() {
            this.$router.push({
                name: 'teacher-center'
            });
        },
        viewCommonClasses() {
            this.$router.push({
                name: 'teacher-common-classes'
            });
        },
        viewPrivateOrder() {
            this.$router.push({
                name: 'teacher-private-classes'
            });
        }
    }
};
</script>

<template lang="pug">
.teacher-home-container
    .avatar-wrapper(@click="viewCenter")
    .teacher-home-wrapper
        .main-wrapper
            p.main-content Hi~李老师
            p.main-content 您共有
                span.number-classes-todo 3
                span 节待上的课
            .link-box
                a.link-view(data-touch="true", @click="viewCommonClasses")
                    span 查看课程表
                    span.circle-arrow-icon
            .link-box
                a.link-view(data-touch="true", @click="viewPrivateOrder")
                    span 预约私教课
                    span.circle-arrow-icon
    .hint-footer-wrapper
        .hint-title 上课提醒
        .hint-wrapper
            .hint-box
                .hint-content 孕产瑜伽孕产瑜伽 30h
                ForkissIcon.hint-time(icon="forkiss-icon-time-white") 2019.11.14 14:30
                ForkissIcon.hint-address(icon="forkiss-icon-address-white") 蓝港店A教室
</template>

<style lang="less">
.teacher-home-container {
    position: relative;
    height: 100%;
    background: url(../../assets/teacher/home-bg.png);
    background-size: cover;
    background-position: center;
    color: #FFF;

    .hint-footer-wrapper {
        position: absolute;
        bottom: 1.02rem;
        left: 0.82rem;
        right: .82rem;
    }
    .avatar-wrapper {
        position: absolute;
        top: .84rem;
        right: .36rem;
        width: 1.08rem;
        height: 1.08rem;
        border-radius: 50%;
        background-image: url(../../assets/classes-avatar1.png);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }

    .teacher-home-wrapper {
        padding: 2.36rem .82rem 1.02rem;
    }

    .main-content {
        font-size: .52rem;

        & + .link-box {
            margin-top: .82rem;
        }

    }
    .number-classes-todo {
        color: #ffd7ae;
    }

    .link-box {
        height: 1.1rem;
        line-height: 1.1rem;
    }
    .link-view {
        position: relative;
        display: inline-block;
        font-size: .36rem;

        &::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 1px;
            background: rgba(255, 255, 255, .6);
        }

        span {
            display: inline-block;
            vertical-align: middle;
            pointer-events: none;
        }
    }

    .circle-arrow-icon {
        display: inline-block;
        width: .36rem;
        height: .36rem;
        background-image: url(../../assets/teacher/circle-arrow-white.svg);
        background-size: contain;
        background-repeat: no-repeat;
        margin-left: .36rem;
    }

    .hint-title {
        text-align: center;
        color: #e2c19d;
        margin-top: .6rem;
        margin-bottom: .3rem;
        font-size: .24rem;

        &::before {
            content: "";
            display: inline-block;
            width: .66rem;
            height: 1px;
            background: #e2c19d;
            margin-right: .15rem;
            vertical-align: super;
        }

        &::after {
            content: "";
            display: inline-block;
            width: .66rem;
            height: 1px;
            background: #e2c19d;
            margin-left: .15rem;
            vertical-align: super;
        }
    }

    .hint-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(255, 255, 255, .2);

    }
    .hint-box {
        padding: .4rem 0;
    }
    .hint-content {
        font-size: .36rem;
        color: #ffd7ae;
    }


}
</style>


// WEBPACK FOOTER //
// src/components/teacher/home.vue